import { createReducer, on } from '@ngrx/store';

import {
  IAssetList,
  IExposureMonitoring,
  IScanConfig,
  IScanConfigNetworkAsset,
  IScanConfigNetworkOverview,
  IScanConfigWebAppOverview,
} from './models/scan-configuration';
import * as actions from './scan-configuration.actions';

export const SCAN_CONFIGURATION_FEATURE_KEY = 'scan-configuration';

export interface ScanConfigurationState {
  scanConfig: IScanConfig;
  webApp: IScanConfigWebAppOverview;
  network: IScanConfigNetworkOverview[];
  networkAssets: IScanConfigNetworkAsset[];
  assetList: IAssetList[];
  exposureMonitoring: IExposureMonitoring | null;
  isLoading: boolean;
}

export const initialState: ScanConfigurationState = {
  scanConfig: null,
  webApp: null,
  network: [],
  networkAssets: [],
  assetList: [],
  exposureMonitoring: null,
  isLoading: false,
};

export const scanConfigurationReducer = createReducer(
  initialState,
  on(actions.getScanConfig, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getScanConfigSuccess, (state, { res }) => ({
    ...state,
    scanConfig: res,
    isLoading: false,
  })),
  on(actions.getWebApp, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getWebAppSuccess, (state, { res }) => ({
    ...state,
    webApp: res,
    isLoading: false,
  })),
  on(actions.getNetwork, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getNetworkSuccess, (state, { res }) => ({
    ...state,
    network: res,
    isLoading: false,
  })),
  on(actions.getNetworkAssets, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getNetworkAssetsSuccess, (state, { res }) => ({
    ...state,
    networkAssets: res,
    isLoading: false,
  })),
  on(actions.getAssetList, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getAssetListSuccess, (state, { assetList }) => ({
    ...state,
    assetList,
    isLoading: false,
  })),
  on(actions.getExposureMonitoring, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getExposureMonitoringSuccess, (state, { res }) => ({
    ...state,
    exposureMonitoring: res,
    isLoading: false,
  })),
  on(actions.getExposureMonitoringFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);
